import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { forgotPassword } from "../../api";
import "../sharedAuth.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");
    setIsLoading(true);

    try {
      const result = await forgotPassword({ email: email.trim() });
      if (result.ok) {
        setSuccess(
          result.message ||
            "If an account exists for this email, a password reset link has been sent.",
        );
      } else {
        setError(result.message || "Unable to start password reset");
      }
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title">Forgot password</h1>
        <p className="auth-subtitle">
          Enter your email and we will send you a reset link.
        </p>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error ? (
            <p className="auth-alert auth-alert-error">{error}</p>
          ) : null}
          {success ? (
            <p className="auth-alert auth-alert-success">{success}</p>
          ) : null}

          <label className="auth-label" htmlFor="email">
            Email
          </label>
          <div className="auth-inputWrap auth-inputWrap-withIcon">
            <Mail className="auth-icon" aria-hidden="true" />
            <input
              id="email"
              type="email"
              className="auth-input"
              placeholder="user@example.com"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              autoComplete="email"
            />
          </div>

          <button className="auth-button" disabled={isLoading} type="submit">
            {isLoading ? "Sending..." : "Send reset link"}
          </button>
        </form>

        <p className="auth-footerText">
          <Link to="/signin" className="auth-link">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
